// TextDecoder polyfill
export function decodeUTF8Bytes(src: Uint8Array): string {
  let index = 0;
  const end = src.byteLength;
  let result = '';

  while (index < end) {
    let chr = src[index];
    index += 1;

    if (chr < 128) {
      result += String.fromCharCode(chr);
      continue;
    }

    if ((chr & 0xE0) === 0xC0) {
      // 2 bytes
      chr = (chr & 0x1F) << 6 |
        (src[index] & 0x3F);
      index += 1;
    } else if ((chr & 0xF0) === 0xE0) {
      // 3 bytes
      chr = (chr & 0x0F) << 12 |
        (src[index] & 0x3F) << 6 |
        (src[index + 1] & 0x3F);
      index += 2;
    } else if ((chr & 0xF8) === 0xF0) {
      // 4 bytes
      chr = (chr & 0x07) << 18 |
        (src[index] & 0x3F) << 12 |
        (src[index + 1] & 0x3F) << 6 |
        (src[index + 2] & 0x3F);
      index += 3;
    }

    if (chr >= 0x010000) {
      // A surrogate pair
      chr -= 0x010000;

      result += String.fromCharCode((chr >>> 10) + 0xD800, (chr & 0x3FF) + 0xDC00);
    } else {
      result += String.fromCharCode(chr);
    }
  }

  return result;
}

export function padZero(num: number, length: number): string {
  if (length <= 0 || num < 0) {
    throw Error('Invalid input.');
  }

  return Array(Math.max(length - String(num).length + 1, 0))
              .join('0') + String(num);
}

export function createDateTimeString(dt: Date = new Date()): string {
  return `${dt.toLocaleDateString()} ${dt.toLocaleTimeString()}`;
}
